export const parsePrice = (s) => Number(String(s || "").replace(/[^\d.]/g, "")) || null;

// Editor labels win; otherwise derive "Best overall / Best value / Highest rated / Most popular"
export function autoLabels(products, labels = {}) {
  const out = {};
  products.forEach((p) => { if (labels[p.id]) out[p.id] = labels[p.id]; });
  if (products.length < 2) return out;
  const used = new Set(Object.values(out));
  const free = (p) => !out[p.id];
  const pick = (arr, label) => {
    if (used.has(label)) return;
    const p = arr.find(free);
    if (p) { out[p.id] = label; used.add(label); }
  };
  pick([products[0]], "Best overall");
  const priced = products.filter((p) => parsePrice(p.price));
  pick([...priced].sort((a, b) => parsePrice(a.price) - parsePrice(b.price)), "Best value");
  pick([...products].sort((a, b) => b.rating - a.rating), "Highest rated");
  pick([...products].sort((a, b) => b.review_count - a.review_count), "Most popular");
  return out;
}
